import React from 'react';
import { Counter } from '../Counter/Counter';
import styles from './VoteCounter.module.css';

export const VoteCounter = ({ total, getParams }) => {
  const {
    counterBgColorStart,
    counterBgColorStop,
    counterColorDirection,
    // цветной круг
    circleBottomBgColorStart,
    circleBottomBgColorStop,
    circleBottomColorDirection,
  } = getParams;
  return (
    <div className={styles['wrapper']}>
      <div className={styles['container']}>
        <div
          className={styles['title']}
          style={{
            backgroundImage: `linear-gradient(${counterColorDirection}deg, ${counterBgColorStart}, ${counterBgColorStop})`,
          }}>
          Проголосовало
        </div>
        <div className={styles['body']}>
          <Counter total={total} />
        </div>
        <span
          className={styles['buble2']}
          style={{
            backgroundImage: `linear-gradient(${circleBottomColorDirection}deg, ${circleBottomBgColorStart}, ${circleBottomBgColorStop})`,
          }}></span>
      </div>
    </div>
  );
};
